var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center","line-height":"30px","padding-top":"50px"}},[_vm._v(" 加载中... ")])}
var staticRenderFns = []

export { render, staticRenderFns }